import { useHistory, useParams } from "react-router-dom";
import OtpInput from "components/otpInput";
import axios from "axios";
import { connect } from "react-redux";
import settings from "client.settings.json";
import { useEffect, useState } from "react";
import { PageComponent } from "components/page";
import { PseudoRadio } from "components/pseudoRadio";

const { api, frontend_app_path } = settings;

const Otp = ({ authenticators = [], mappings, bgCol }) => {
  const history = useHistory();
  const { messageId, tenantId } = useParams();
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [authId, setAuthId] = useState(authenticators[0]._id || "");
  const [token, setToken] = useState("");

  const handleSubmit = async (token) => {
    try {
      setIsSubmitting(true);
      await axios.post(`${api}/api/login/authenticator`, {
        authId,
        messageId,
        token,
      });
      history.push(`${frontend_app_path}${tenantId}/messages/${messageId}`);
    } catch (error) {
      console.error(error);
      setError(error.response?.data?.error || error.message);
      setIsSubmitting(false);
    }
  };

  const btnFunctions = {
    E_DELIVERY_ENTER_CODE_PAGE_AUTHENTICATOR: [() => handleSubmit(token)],
  };

  return (
    <div>
      <PageComponent
        noHeader={true}
        content={mappings["E_DELIVERY_LOGIN_PAGE_AUTHENTICATOR"]}
        styles={{ paddingBottom: "0", minHeight: "0" }}
        children2={
          <OtpInput
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            returnToken={(token) => setToken(token)}
            error={error}
          />
        }
      >
        <ul className="PhoneSelect">
          {authenticators.map(({ _id, publicValue, name = publicValue }) => {
            return (
              <li key={_id}>
                <PseudoRadio condition={authId === _id} bgCol={bgCol} />
                <input
                  style={{ opacity: "0" }}
                  onChange={({ target: { value } }) => setAuthId(value)}
                  checked={authId === _id}
                  className="mr-2"
                  type="radio"
                  value={_id}
                  id={_id}
                  name="authenticator"
                />
                <label htmlFor={_id}>{name}</label>
              </li>
            );
          })}
        </ul>
        <hr />
      </PageComponent>
      {/* <hr />
      <PageComponent
        noHeader={true}
        content={mappings["E_DELIVERY_ENTER_CODE_PAGE_AUTHENTICATOR"]}
        btnFunctions={btnFunctions["E_DELIVERY_ENTER_CODE_PAGE_AUTHENTICATOR"]}
        styles={{paddingTop: "0"}}
        disabled={isSubmitting}
      >
        <OtpInput
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          returnToken={(token) => setToken(token)}
        />
      </PageComponent> */}
    </div>
  );
};

const mapStateToProps = (state) => state.i18n;
export default connect(mapStateToProps)(Otp);
